module.exports = __webpack_public_path__ + "img/reset-password.8a3bf75c.png";